import script from "./KbCategories.vue?vue&type=script&lang=ts&setup=true"
export * from "./KbCategories.vue?vue&type=script&lang=ts&setup=true"

import "./KbCategories.vue?vue&type=style&index=0&id=7ff3ffe6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff3ffe6"]])

export default __exports__